/** Matches API `MunicipalDegradableDetailApiModel` (camelCase). DB columns remain Kind/Code. */
export interface IMunicipalDegradableDetail {
    id: string;
    indicatorType: string;
    applies: string;
    description: string;
    isActive: boolean;
    isDeleted: boolean;
    source: string;
    sourceVersion: string;
    effectiveFromUtc: string;
    createdAtUtc: string;
    updatedAtUtc: string;
    createdByDisplayName?: string | null;
    lastUpdatedByDisplayName?: string | null;
    deletedAuditAtUtc?: string | null;
    deletedByDisplayName?: string | null;
    disabledAuditAtUtc?: string | null;
    disabledByDisplayName?: string | null;
}

export const MUNICIPAL_DEGRADABLE_INDICATOR_TYPES = ["Municipal", "Degradable"] as const;
export type MunicipalDegradableIndicatorType = (typeof MUNICIPAL_DEGRADABLE_INDICATOR_TYPES)[number];

export const MUNICIPAL_DEGRADABLE_APPLIES_VALUES = ["Yes", "No"] as const;

export type MunicipalDegradableUpdatePayload = {
    id: string;
    description: string;
};
